import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { ALL } from "../../constants";
import { isEmptyString } from "../../helperFunc";
import { selectedSPWUpdated } from "../../redux/reducer";
import SelectionFilter from "../FilterSection/SelectionFilter";

let SPWfilterInitialState = {
  label: "SPW",
  value: "spw",
  placeholder: "",
  type: "select",
  options: [],
  selected: "",
  unit: "",
};

function SpwFilterData({ SPWData, isFetching }) {
  const [spwfilter, setSPWFilter] = useState(SPWfilterInitialState);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const location = useLocation();


  const handleSPWChange = (e) => {

    e.preventDefault();
    const spw = e.target.value;
    setSPWFilter((prevSPWFilterData) => {
      return {
        ...prevSPWFilterData,
        selected: spw,
      };
    });

    let queryparam = searchParams.get("catid") ? { catid: searchParams.get("catid"), spw } : { spw };
    setSearchParams(queryparam, { replace: true, state:  { internalNavigation: location?.state?.internalNavigation ,pointingsRefreshed:!location?.state?.internalNavigation } });
    dispatch(selectedSPWUpdated({ selectedSPW: spw }));
  };

  useEffect(() => {
    const spwId = searchParams.get("spw");
    if (SPWData && !isFetching) {
      const mapSpwToObject = (spw) => ({ name: spw, value: spw });
      const spwOptions = SPWData?.spws?.map(mapSpwToObject) || [];

      const isReferenceSpwEmpty = isEmptyString(SPWData?.reference_spw);
      if (isReferenceSpwEmpty) spwOptions.push({ name: ALL, value: ALL });

      let selectedValue = isReferenceSpwEmpty ? ALL : SPWData?.reference_spw;
      selectedValue = spwId ? spwId : selectedValue;

      setSPWFilter((prevSPWFilterData) => {
        return {
          ...prevSPWFilterData,
          options: [...spwOptions],
          selected: selectedValue,
        };
      });
      dispatch(selectedSPWUpdated({ selectedSPW: selectedValue }));
    }
  }, [SPWData, isFetching]);

  const renderSPWFilterSection = () => {
    return (
      <div className="spwFilter">
        <h4>{spwfilter.label}</h4>
        <SelectionFilter
          filter={spwfilter}
          onChange={handleSPWChange}
          defaultValue={spwfilter.selected}
        />
      </div>
    );
  };

  return (
    <>
      {renderSPWFilterSection()}
    </>
  );
}

export default SpwFilterData;
